import React from "react";
import Marquee from "react-fast-marquee";

const MarqueeSection = () => {
  return (
    <div className="bg-[#504e9a] py-2">
      <Marquee speed={50} gradient={false} className="py-3">
        <span className="text-white text-5xl mx-3">✦</span>
        <span className="text-white font-bold text-5xl mx-5">Technology</span>
        <span className="text-white text-5xl mx-3">✦</span>
        <span className="text-white font-bold text-5xl mx-5">Business</span>
        <span className="text-white text-5xl mx-3">✦</span>
        <span className="text-white font-bold text-5xl mx-5">IT Solutions</span>
        <span className="text-white text-5xl mx-3">✦</span>
        <span className="text-white font-bold text-5xl mx-5">Technology</span>
        <span className="text-white text-5xl mx-3">✦</span>
        <span className="text-white font-bold text-5xl mx-5">Work Process</span>
      </Marquee>
    </div>
  );
};

export default MarqueeSection;
